import { FC } from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import Button from '@app.components/Button'
import Modal from '@app.components/Modal/Modal'

interface ConfirmCloseModalProps {
  onClose: () => void
  onConfirm: () => void
}

const ConfirmCloseModal: FC<ConfirmCloseModalProps> = ({
  onClose,
  onConfirm,
}) => {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  return (
    <Modal open onClose={onClose}>
      <StyledWrapper>
        <div className="title">
          아직 저장되지 않은 <br />
          내용이 있습니다.
          <Close className="close-btn" onClick={onClose} />
        </div>
        <div className="desc">변경한 내용을 삭제하시겠어요?</div>
        <div className="button-box">
          <Button className="button" color="grey" onClick={onClose}>
            취소
          </Button>
          <Button className="button" onClick={handleConfirm}>
            확인
          </Button>
        </div>
      </StyledWrapper>
    </Modal>
  )
}

export default ConfirmCloseModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;

  .title {
    font-size: 24px;
    font-weight: 600px;
    line-height: 1.3;
    text-align: center;
  }
  .close-btn {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .desc {
    font-size: 16px;
    font-weight: 400;
  }
  .button-box {
    display: flex;
    gap: 10px;
    padding-top: 50px;
    .button {
      width: 88px;
      height: 50px;
      font-size: 16px;
      color: #fff;
    }
  }
`
